import moment from "moment";
import React, { useEffect, useState } from "react";
import _ from "lodash";

import {
  ListItemCalcWrapper,
  ListItemContent,
  ListItemDSCRSignifier,
  ListItemDebtYieldSignifier,
  ListItemDeliveryPeriodWrapper,
  ListItemFlexEndWrapper,
  ListItemIconWrapper,
  ListItemSubTitle,
  ListItemText,
  ListItemTitle,
  ListItemWrapper,
  StyledButtonText,
} from "./styles";

const ReportConfigListItem = props => {
  const { id, lastPublishedDate, onClick, reportName, shouldCalculateDscr, shouldCalculateDebtYield, allDealLoans, dealId, history } = props;

  let lender = "";
  let seniority = "";
  let reportFrequency = "";

  const [deliverableOptions, setDeliverableOptions] = useState({
    deliveryPeriodDays: "--",
    closingDate: ""
  });

  if (reportName) {
    const splitReportName = reportName.split(" - ");
    [lender, seniority, reportFrequency] = splitReportName;
  }

  const goTo = (e) => {
    e.stopPropagation();
    history.push(`/deal/${dealId}/lender-reports/${id}`);
  };

  useEffect(() => {
    if (allDealLoans) {
      for (const loan of allDealLoans) {
        const deliverable = loan.deliverables?.find(o => o.lcrReportGroupId === id);

        if (deliverable) {
          const deliveryPeriodDays = deliverable.deliveryPeriodDays;
          const closingDate = loan.closingDate;

          setDeliverableOptions({
            deliveryPeriodDays,
            closingDate
          });
        }
      }
    }
  }, [allDealLoans]);

  const getFormattedLastPublishedDate = () => {
    if (lastPublishedDate) {
      return `Last published on ${moment.utc(lastPublishedDate).format("MMMM Do, YYYY")}`;
    }

    return "Not published yet";
  };

  const getFormattedText = () => {
    let formattedText = "";

    if (lender && seniority) {
      formattedText = `${lender} - ${seniority}`;

      if (deliverableOptions.closingDate) {
        formattedText = `${formattedText} - ${deliverableOptions.closingDate}`;
      }
    }

    return formattedText;
  };

  const getDSCRSignifier = () => {
    if (!shouldCalculateDscr) {
      return "";
    }

    return <ListItemDSCRSignifier>DSCR</ListItemDSCRSignifier>;
  };

  const getDebtYieldSignifier = () => {
    if (!shouldCalculateDebtYield) {
      return "";
    }

    return <ListItemDebtYieldSignifier>DY</ListItemDebtYieldSignifier>;
  };

  return (
    <ListItemWrapper id="list-item-root" onClick={onClick || _.noop}>
      <ListItemContent style={{ width: "60%" }}>
        <ListItemSubTitle>{getFormattedLastPublishedDate()}</ListItemSubTitle>
        <ListItemTitle>{reportFrequency}</ListItemTitle>
        <ListItemText>{getFormattedText()}</ListItemText>
      </ListItemContent>
      <ListItemContent style={{ width: "40%" }}>
        <ListItemDeliveryPeriodWrapper>
          <ListItemText>
            {deliverableOptions.deliveryPeriodDays !== "--" ? `${deliverableOptions.deliveryPeriodDays} day delivery period` : ""}
          </ListItemText> 
        </ListItemDeliveryPeriodWrapper>
        <ListItemCalcWrapper>
          {(shouldCalculateDebtYield || shouldCalculateDscr) ?
            <>
              <ListItemIconWrapper>
                {getDSCRSignifier()}
                {getDebtYieldSignifier()}
              </ListItemIconWrapper>
              <ListItemFlexEndWrapper>
                <StyledButtonText label="See calculation details" iconName="launch" alignRight={true} onClick={(e) => goTo(e)} />
              </ListItemFlexEndWrapper> 
            </>
          : <></> }
        </ListItemCalcWrapper>
      </ListItemContent>
      </ListItemWrapper>
  );
};

export default ReportConfigListItem;
